import React from "react";
import PropTypes from "prop-types";
import SmartText from "../../utils/TextHandler";
import SmartImage from "../../utils/ImageHandler";
import Image from "../Global/Image";
import Moment from "react-moment";
import SmartTag from "../../utils/TagHandler";
import Ratings from "../Global/Ratings";
import PlatformLinks from "../Global/PlatformLinks";
import Link from "../Global/Link";

const CardGameDetails = (props) => {
  const { item, size } = props;

  return (
    <div className={`d-flex flex-column brand-shadow brand-radius p-4 p-md-5`}>
      <div className="border-bottom pb-4 mb-4 text-center ">
        {item.lifecycle && (
          <span className="brand-text-pink fw-bold brand-text-nowrap">
            {SmartTag(item.lifecycle)}
          </span>
        )}
        {item.lifecycle && item.type && (
          <span className="mx-2 brand-text-black-50">|</span>
        )}
        {item.type && (
          <span className="fw-bold brand-text-nowrap">{item.type}</span>
        )}
      </div>

      {item.icon && (
        <div className="row border-bottom pb-4 mb-4 text-center">
          <Image
            src={item.icon ? item.icon.filename : null}
            sm="150x150"
            md="200x200"
            lg="200x200"
            alt={item.title && item.title}
            className="brand-radius"
          />
        </div>
      )}
      <div className="border-bottom pb-4 mb-4 text-center ">
        {item.title && <h1 className="brand-font m-0">{item.title}</h1>}
      </div>
      {item.platforms && (
        <div className="row border-bottom pb-4 mb-4 text-center ">
          <PlatformLinks platforms={item.platforms} link={true} size="30x30" />
        </div>
      )}
      {item.date && (
        <div className="row border-bottom pb-4 mb-4 text-center">
          <div className="col-12 brand-text-black-50">Released:</div>
          <div className="col-12">
            <Moment format="D MMM, YYYY" date={item.date} />
          </div>
        </div>
      )}
      {item.developer && (
        <div className="row border-bottom pb-4 mb-4 text-center">
          <div className="col-12 brand-text-black-50">Developer:</div>
          <div className="col-12">{item.developer}</div>
        </div>
      )}
      {item.ratings_new && item.ratings_new.length > 0 && (
        <div className="row border-bottom pb-4 mb-4 text-center ">
          <Ratings
            ratings={item.ratings_new}
            sm="0x100"
            md="0x100"
            lg="0x100"
          />
        </div>
      )}

      {(item.presspack?.story?.slug || item.presspack?.url) && (
        <div className="row border-bottom pb-4 mb-4 text-center ">
          <Link button to={item.presspack && item.presspack} icon>
            {item.presspack.alt ? item.presspack.alt : "Press Pack"}
          </Link>
        </div>
      )}
    </div>
  );
};

export default CardGameDetails;

CardGameDetails.propTypes = {
  settings: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CardGameDetails.defaultProps = {
  settings: null,
};
